import router from "./index";

export default [
  {
    path: "/course",
    component: () => import('../views/Course/Course'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") != "student")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '课程'
    },
    children: [
      {
        path: '/',
        redirect: 'CourseList'
      },
      {
        path: 'CourseList',
        component: () => import('../views/Course/CourseList/CourseList'),
        meta: {
          title: '课程列表'
        },
      },
      {
        path: 'AddCourse',
        component: () => import('../views/Course/AddCourse/AddCourse'),
        meta: {
          title: '添加课程'
        },
      },
      {
        path: 'LookStudent',
        component: () => import('../views/Course/LookStudent/LookStudent'),
        meta: {
          title: '该课程学生'
        },
      },
      {
        path: 'ModifyCourse',
        component: () => import('../views/Course/ModifyCourse/ModifyCourse'),
        meta: {
          title: '修改课程'
        },
      },
    ]
  },
]
